import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_CLIENT_LOGO = "GET_CLIENT_LOGO";

export const service = async (data) => {
  const options: object = {
    url: `/api/Client/GetClientLogo/`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CLIENT_LOGO, service, mock);
